/**
 * トークンの保持。**メモリだけ**に置く。
 *
 * localStorage / sessionStorage / IndexedDB / Cookie には書かない。XSS で読める場所に
 * 置かないのが理由で、代わりにリロードで消えることを受け入れる（消えたら認可し直す）。
 * 「書いていないこと」はテスト（storage-isolation.test.ts）が実際の storage を
 * 覗いて固定する。
 */

import type { TokenSet } from "./oauth";

/** 失効の手前で取り直すための余裕 */
const EXPIRY_SKEW_MS = 30_000;

export class InMemoryTokenStore {
  #tokens: TokenSet | null = null;

  set(tokens: TokenSet | null): void {
    this.#tokens = tokens;
  }

  clear(): void {
    this.#tokens = null;
  }

  get(): TokenSet | null {
    return this.#tokens;
  }

  accessToken(): string | null {
    return this.#tokens?.accessToken ?? null;
  }

  refreshToken(): string | null {
    return this.#tokens?.refreshToken ?? null;
  }

  isExpired(now: number = Date.now()): boolean {
    const expiresAt = this.#tokens?.expiresAt ?? null;
    if (this.#tokens === null) {
      return true;
    }
    if (expiresAt === null) {
      return false;
    }
    return now >= expiresAt - EXPIRY_SKEW_MS;
  }
}
